var _defineProperty = require("/codebuild/output/src4083160994/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/codebuild/output/src4083160994/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread2");
var _asyncToGenerator = require("/codebuild/output/src4083160994/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/codebuild/output/src4083160994/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/codebuild/output/src4083160994/src/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var _ = require('lodash');
var _require = require('./utils'),
  columnToLetter = _require.columnToLetter;
var _require2 = require('./errors'),
  GoogleSpreadsheetFormulaError = _require2.GoogleSpreadsheetFormulaError;
var GoogleSpreadsheetCell = /*#__PURE__*/function () {
  "use strict";

  function GoogleSpreadsheetCell(parentSheet, rowIndex, columnIndex, cellData) {
    _classCallCheck(this, GoogleSpreadsheetCell);
    this._sheet = parentSheet; // the parent GoogleSpreadsheetWorksheet instance
    this._row = rowIndex;
    this._column = columnIndex;
    this._updateRawData(cellData);
    return this;
  }

  // newData can be undefined/null if the cell is totally empty and unformatted
  _createClass(GoogleSpreadsheetCell, [{
    key: "_updateRawData",
    value: function _updateRawData() {
      var newData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._rawData = newData;
      this._draftData = {}; // stuff to save
      this._error = null;
      if (_.get(this._rawData, 'effectiveValue.errorValue')) {
        this._error = new GoogleSpreadsheetFormulaError(this._rawData.effectiveValue.errorValue);
      }
    }

    // CELL LOCATION/ADDRESS /////////////////////////////////////////////////////////////////////////
  }, {
    key: "rowIndex",
    get: function get() {
      return this._row;
    }
  }, {
    key: "columnIndex",
    get: function get() {
      return this._column;
    }
  }, {
    key: "a1Column",
    get: function get() {
      return columnToLetter(this._column + 1);
    }
  }, {
    key: "a1Row",
    get: function get() {
      return this._row + 1;
    } // a1 row numbers start at 1 instead of 0
  }, {
    key: "a1Address",
    get: function get() {
      return "".concat(this.a1Column).concat(this.a1Row);
    }

    // CELL CONTENTS - VALUE/FORMULA/NOTES ///////////////////////////////////////////////////////////
  }, {
    key: "value",
    get: function get() {
      // const typeKey = _.keys(this._rawData.effectiveValue)[0];
      if (this._draftData.value !== undefined) throw new Error('Value has been changed');
      if (this._error) return this._error;
      if (!this._rawData.effectiveValue) return null;
      return _.values(this._rawData.effectiveValue)[0];
    },
    set: function set(newValue) {
      if (_.isBoolean(newValue)) {
        this._draftData.valueType = 'boolValue';
      } else if (_.isString(newValue)) {
        if (newValue.substr(0, 1) === '=') this._draftData.valueType = 'formulaValue';else this._draftData.valueType = 'stringValue';
      } else if (_.isFinite(newValue)) {
        this._draftData.valueType = 'numberValue';
      } else if (_.isNil(newValue)) {
        // null or undefined
        this._draftData.valueType = 'stringValue';
        newValue = '';
      } else {
        throw new Error('Set value to boolean, string, or number');
      }
      this._draftData.value = newValue;
    }
  }, {
    key: "valueType",
    get: function get() {
      // an error only happens with a formula
      if (this._error) return 'errorValue';
      if (!this._rawData.effectiveValue) return null;
      return _.keys(this._rawData.effectiveValue)[0];
    }
  }, {
    key: "formattedValue",
    get: function get() {
      return this._rawData.formattedValue || null;
    },
    set: function set(newVal) {
      throw new Error('You cannot modify the formatted value directly');
    }
  }, {
    key: "formula",
    get: function get() {
      return _.get(this._rawData, 'userEnteredValue.formulaValue', null);
    },
    set: function set(newValue) {
      if (newValue.substr(0, 1) !== '=') throw new Error('formula must begin with "="');
      this.value = newValue; // use existing value setter
    }
  }, {
    key: "formulaError",
    get: function get() {
      return this._error;
    }
  }, {
    key: "hyperlink",
    get: function get() {
      if (this._draftData.value) throw new Error('Save cell to be able to read hyperlink');
      return this._rawData.hyperlink;
    },
    set: function set(val) {
      throw new Error('Do not set hyperlink directly. Instead set cell.formula, for example `cell.formula = \'=HYPERLINK("http://google.com", "Google")\'`');
    }
  }, {
    key: "note",
    get: function get() {
      return this._draftData.note !== undefined ? this._draftData.note : this._rawData.note;
    },
    set: function set(newVal) {
      if (newVal === null || newVal === undefined) newVal = '';
      if (!_.isString(newVal)) throw new Error('Note must be a string');
      if (newVal === this._rawData.note) delete this._draftData.note;else this._draftData.note = newVal;
    }

    // CELL FORMATTING ///////////////////////////////////////////////////////////////////////////////
  }, {
    key: "userEnteredFormat",
    get: function get() {
      return this._rawData.userEnteredFormat;
    },
    set: function set(newVal) {
      throw new Error('Do not modify directly, instead use format properties');
    }
  }, {
    key: "effectiveFormat",
    get: function get() {
      return this._rawData.effectiveFormat;
    },
    set: function set(newVal) {
      throw new Error('Read-only');
    }
  }, {
    key: "_getFormatParam",
    value: function _getFormatParam(param) {
      // we freeze the object so users don't change nested props accidentally
      // TODO: figure out something that would throw an error if you try to update it?
      if (_.get(this._draftData, "userEnteredFormat.".concat(param))) {
        throw new Error('User format is unsaved - save the cell to be able to read it again');
      }
      return Object.freeze(this._rawData.userEnteredFormat[param]);
    }
  }, {
    key: "_setFormatParam",
    value: function _setFormatParam(param, newVal) {
      if (_.isEqual(newVal, _.get(this._rawData, "userEnteredFormat.".concat(param)))) {
        _.unset(this._draftData, "userEnteredFormat.".concat(param));
      } else {
        _.set(this._draftData, "userEnteredFormat.".concat(param), newVal);
        this._draftData.clearFormat = false;
      }
    }

    // format getters
  }, {
    key: "numberFormat",
    get: function get() {
      return this._getFormatParam('numberFormat');
    },
    set:
    // format setters
    function set(newVal) {
      return this._setFormatParam('numberFormat', newVal);
    }
  }, {
    key: "backgroundColor",
    get: function get() {
      return this._getFormatParam('backgroundColor');
    },
    set: function set(newVal) {
      return this._setFormatParam('backgroundColor', newVal);
    }
  }, {
    key: "borders",
    get: function get() {
      return this._getFormatParam('borders');
    },
    set: function set(newVal) {
      return this._setFormatParam('borders', newVal);
    }
  }, {
    key: "padding",
    get: function get() {
      return this._getFormatParam('padding');
    },
    set: function set(newVal) {
      return this._setFormatParam('padding', newVal);
    }
  }, {
    key: "horizontalAlignment",
    get: function get() {
      return this._getFormatParam('horizontalAlignment');
    },
    set: function set(newVal) {
      return this._setFormatParam('horizontalAlignment', newVal);
    }
  }, {
    key: "verticalAlignment",
    get: function get() {
      return this._getFormatParam('verticalAlignment');
    },
    set: function set(newVal) {
      return this._setFormatParam('verticalAlignment', newVal);
    }
  }, {
    key: "wrapStrategy",
    get: function get() {
      return this._getFormatParam('wrapStrategy');
    },
    set: function set(newVal) {
      return this._setFormatParam('wrapStrategy', newVal);
    }
  }, {
    key: "textDirection",
    get: function get() {
      return this._getFormatParam('textDirection');
    },
    set: function set(newVal) {
      return this._setFormatParam('textDirection', newVal);
    }
  }, {
    key: "textFormat",
    get: function get() {
      return this._getFormatParam('textFormat');
    },
    set: function set(newVal) {
      return this._setFormatParam('textFormat', newVal);
    }
  }, {
    key: "hyperlinkDisplayType",
    get: function get() {
      return this._getFormatParam('hyperlinkDisplayType');
    },
    set: function set(newVal) {
      return this._setFormatParam('hyperlinkDisplayType', newVal);
    }
  }, {
    key: "textRotation",
    get: function get() {
      return this._getFormatParam('textRotation');
    },
    set: function set(newVal) {
      return this._setFormatParam('textRotation', newVal);
    }
  }, {
    key: "clearAllFormatting",
    value: function clearAllFormatting() {
      // need to track this separately since by setting/unsetting things, we may end up with
      // this._draftData.userEnteredFormat as an empty object, but not an intent to clear it
      this._draftData.clearFormat = true;
      delete this._draftData.userEnteredFormat;
    }

    // SAVING + UTILS ////////////////////////////////////////////////////////////////////////////////

    // returns true if there are any updates that have not been saved yet
  }, {
    key: "_isDirty",
    get: function get() {
      // have to be careful about checking undefined rather than falsy
      // in case a new value is empty string or 0 or false
      if (this._draftData.note !== undefined) return true;
      if (_.keys(this._draftData.userEnteredFormat).length) return true;
      if (this._draftData.clearFormat) return true;
      if (this._draftData.value !== undefined) return true;
      return false;
    }
  }, {
    key: "discardUnsavedChanges",
    value: function discardUnsavedChanges() {
      this._draftData = {};
    }
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this._sheet.saveUpdatedCells([this]);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }() // used by worksheet when saving cells
    // returns an individual batchUpdate request to update the cell
  }, {
    key: "_getUpdateRequest",
    value: function _getUpdateRequest() {
      // this logic should match the _isDirty logic above
      // but we need it broken up to build the request below
      var isValueUpdated = this._draftData.value !== undefined;
      var isNoteUpdated = this._draftData.note !== undefined;
      var isFormatUpdated = !!_.keys(this._draftData.userEnteredFormat || {}).length;
      var isFormatCleared = this._draftData.clearFormat;

      // if no updates, we return null, which we can filter out later before sending requests
      if (!_.some([isValueUpdated, isNoteUpdated, isFormatUpdated, isFormatCleared])) {
        return null;
      }

      // build up the formatting object, which has some quirks...
      var format = _objectSpread(_objectSpread({}, this._rawData.userEnteredFormat), this._draftData.userEnteredFormat);
      // if background color already set, cell has backgroundColor and backgroundColorStyle
      // but backgroundColorStyle takes precendence so we must remove to set the color
      // see https://developers.google.com/sheets/api/reference/rest/v4/spreadsheets/cells#CellFormat
      if (_.get(this._draftData, 'userEnteredFormat.backgroundColor')) {
        delete format.backgroundColorStyle;
      }
      return {
        updateCells: {
          rows: [{
            values: [_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, isValueUpdated && {
              userEnteredValue: _defineProperty({}, this._draftData.valueType, this._draftData.value)
            }), isNoteUpdated && {
              note: this._draftData.note
            }), isFormatUpdated && {
              userEnteredFormat: format
            }), isFormatCleared && {
              userEnteredFormat: {}
            })]
          }],
          // turns into a string of which fields to update ex "note,userEnteredFormat"
          fields: _.keys(_.pickBy({
            userEnteredValue: isValueUpdated,
            note: isNoteUpdated,
            userEnteredFormat: isFormatUpdated || isFormatCleared
          })).join(','),
          start: {
            sheetId: this._sheet.sheetId,
            rowIndex: this.rowIndex,
            columnIndex: this.columnIndex
          }
        }
      };
    }
  }]);
  return GoogleSpreadsheetCell;
}();
module.exports = GoogleSpreadsheetCell;